import { CircularProgress, Tooltip } from "@mui/material";
import React, { memo, useEffect } from "react";
import { useSelector } from "react-redux";
import LineAreaChartNivo from "../../../common/components/chartNivo/oldChart/lineAreaChart";
import Linechart from "../../../common/components/chartNivo/oldChart/lineChart";
import { ResponsiveDivChart } from "../../../styledComponents/component";
import { riskOfInvestmentAnalysis } from "../nlg/nlg";
import Description from "../description";
import { Info } from "@mui/icons-material";
import { makeStyles } from "@mui/styles";
import { useVideoTooltip } from "../../../common/customHook/useVideoTootip";
import { useTheme, useMediaQuery } from "@mui/material";

const useStyles = makeStyles((theme) => ({
  tooltip: {
    maxWidth: 250,
    fontSize: 12,
    padding: 5,
  },
}));

const RiskBox = memo(({ risk, tip }) => {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const reducerportfolio = useSelector(
    (state) => state.select_portfolio_history_reducer,
  );
  const loadingReducer = useSelector((state) => state.loading);

  const analysis = riskOfInvestmentAnalysis(reducerportfolio.data);

  const handleClassChartParent = () => {
    let length = reducerportfolio.data.length;
    if (length > 30 && length < 80) {
      return "w-[1100px] h-[400px]";
    }
    if (length > 80 && length < 200) {
      return "w-[2200px] h-[400px]";
    }
    if (length > 200) {
      return "w-[8000px] h-[400px]";
    } else {
      return "w-[500px] lg:w-full h-[400px]";
    }
  };

  return (
    <>
      <div
        className="flex justify-between items-center"
        style={{ width: "max-content" }}
      >
        <h1 className="pr-3 mt-2 mx-2">ریسک سرمایه گذاری</h1>
        <Tooltip
          className="mt-3"
          title={<p className="p-2 m-0">{tip}</p>}
          placement={isMobile ? "bottom" : "left"}
          arrow
          classes={{ tooltip: classes.tooltip }}
          enterTouchDelay={1}
        >
          <img src="/media/image/Group 12485.png" />
        </Tooltip>
        <span className={`mt-3 mr-1 hover:cursor-pointer`}></span>
      </div>
      <div className="grid grid-cols-12">
        <div className="col-span-12 lg:col-span-4">
          <div className="text-sm text-gray-700 p-5">
            نمودار پیش رو، ریسک سرمایه‌گذاری شما در بازه انتخاب شده را نمایش
            می‌دهد. در این نمودار، شاخص فراریت در هر روز بر اساس میزان دارایی کل
            شما در انتهای روزهای معاملاتی محاسبه شده است.
          </div>
          <Description analysis={analysis} />
        </div>
        <div className="col-span-12 lg:col-span-8">
          {/* <SummaryTable reducerselectKey={reducerselectKey} /> */}
          {loadingReducer.loading ? (
            <div className="h-full w-full flex justify-center items-center">
              <CircularProgress />
            </div>
          ) : (
            <ResponsiveDivChart>
              <div
                className={handleClassChartParent()}
                style={{ direction: "ltr" }}
              >
                <Linechart reducerportfolio={reducerportfolio} risk />
              </div>
            </ResponsiveDivChart>
          )}
        </div>
      </div>
    </>
  );
});

export default RiskBox;
